import "./nav_desktop/nav_desktop.js";
import "./nav_mobile/nav_mobile.js";
import "./language_switcher/language_switcher.js";
import "./site_switcher/site_switcher.js";
